// extracted by mini-css-extract-plugin
export default {"modalOverlay":"instagramModal_modalOverlay__zHPUv","modalContent":"instagramModal_modalContent__sGDnH"};